// extracted by mini-css-extract-plugin
export default {"login_bg":"login_login_bg__wurEF","login_submit":"login_login_submit__o6Pmz"};